// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"30835207","36":"a7af92a3","145":"44339db1","267":"17912cc2","453":"cbeff4a5","640":"c5eacba0"}[chunkId] + ".chunk.js";
};